import moment from "moment";
import React, { createContext, useState, useEffect } from "react";

const GLobalStoreContext = createContext();

export const GLobalStoreProvider = ({ children }) => {
  const isBrowser = typeof window !== "undefined";
  const user = isBrowser ? JSON.parse(localStorage?.getItem("user")) : null;
  // --------------- ** STATES ** -----------------

  // ----- user's orders list
  const [allOrders, setAllOrders] = useState(null);
  const [storeStates, setStoreStates] = useState({
    isGoogleMapsScriptLoaded: false,
  });
  const [userStates, setUserStates] = useState({
    defaultReadyTime: "",
    defaultArrivingTime: "",
    defaultCelebrationDate: moment().add(1, "days").toISOString(),
  });

  // ------- date and slot informations --------------------
  const [orderInfo, setOrderInfo] = useState({
    convenienceFee: 0,
    selectedTimeSlot: "",
    selectedDate: moment().add(1, "day").format("DD-MM-YYYY"), // it will set tomorrow date
  });

  const [wishlistedArray, setWishlistedArray] = useState([]); // stores the wishlisted product _id
  const [wishlistedArrayObj, setWishlistedArrayObj] = useState([]); // stores the wishlisted product's complete info

  const [freebiesArray, setFreebiesArray] = useState({
    isLoading: false,
    data: null,
  });

  //------------------ ** USE EFFECTS ** ------------------
  useEffect(() => {
    handleContentLoadOnUserChange();
    // eslint-disable-next-line
  }, []);

  const handleContentLoadOnUserChange = async () => {
    // wishlist first time load
    user && toggleWishlistItem();
  };

  const toggleWishlistItem = async (product, type) => {
    try {
      const { handleWishlistedProducts } = await import("../api/wishlistApi");
      const res = await handleWishlistedProducts({
        mode: type,
        productCode: product?._id,
      });

      if (res?.isSuccess) {
        setWishlistedArrayObj(res.wishlistedProducts);
        const resWishlistedArray = res.wishlistedProducts.map(
          (curr) => curr._id
        );
        setWishlistedArray(resWishlistedArray);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  return (
    <GLobalStoreContext.Provider
      value={{
        allOrders,
        setAllOrders,
        orderInfo,
        setOrderInfo,
        wishlistedArray,
        setWishlistedArray,
        wishlistedArrayObj,
        setWishlistedArrayObj,
        toggleWishlistItem,
        freebiesArray,
        setFreebiesArray,
        userStates,
        setUserStates,
        storeStates,
        setStoreStates,
      }}
    >
      {children}
    </GLobalStoreContext.Provider>
  );
};

export default GLobalStoreContext;
